import React from 'react';

const MOODS = [
  { emoji: '😊', label: 'מצוין', value: 'excellent', color: 'bg-brand-100 border-brand-600' },
  { emoji: '🙂', label: 'טוב', value: 'good', color: 'bg-brand-50 border-brand-400' },
  { emoji: '😐', label: 'ממוצע', value: 'neutral', color: 'bg-gold-100 border-gold-500' },
  { emoji: '😔', label: 'קשה', value: 'difficult', color: 'bg-bloom-50 border-bloom-400' },
  { emoji: '😰', label: 'קריטי', value: 'critical', color: 'bg-bloom-100 border-bloom-600' },
];

const MoodSelector = ({ selected, onSelect }) => {
  return (
    <div className="bg-white rounded-xl p-4 border border-stone-200">
      <p className="text-sm font-semibold text-stone-700 mb-4">
        😊 איך אתה מרגיש היום?
      </p>
      <div className="grid grid-cols-5 gap-2">
        {MOODS.map((mood) => (
          <button
            key={mood.value}
            onClick={() => onSelect(mood.value)}
            className={`flex flex-col items-center justify-center p-3 rounded-lg border-2 transition-all ${
              selected === mood.value
                ? `${mood.color} scale-105 shadow`
                : 'bg-stone-50 border-transparent hover:bg-stone-100'
            }`}
          >
            <span className="text-2xl mb-1">{mood.emoji}</span>
            <span className="text-xs text-stone-700 text-center leading-tight">
              {mood.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export { MOODS };
export default MoodSelector;
